/**
 * Slug helpers for custom template records.
 */

import { slugify } from '../export/generators.js';

const TEMPLATE_SLUG_RE = /^[a-z0-9](?:[a-z0-9-]{4,78}[a-z0-9])$/;

export function slugifyTemplateName(name = 'untitled') {
  return (slugify(name) || 'untitled').slice(0, 60).replace(/-+$/g, '') || 'untitled';
}

export function validateTemplateSlug(slug) {
  return TEMPLATE_SLUG_RE.test(String(slug || ''));
}
